import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
    <div class="heading01 type01">
        <h1>{{ 'evaluation.360 feedback' | translate }}</h1>
        <ul class="actions01">
            <li>
                <a class="btn add" ui-sref="authorized.evaluation.import">{{ 'evaluation.Plan 360 feedback' | translate }}</a>
            </li>
        </ul>
    </div>
    <list-factory-empty list="vm.list"></list-factory-empty>
    <table class="data01" datatable dt-options="vm.DATATABLES" ng-if="vm.list.items.length && !vm.loading">
        <thead>
        <tr>
            <th>{{ 'evaluation.Name' | translate }}</th>
            <th>{{ 'evaluation.Deadline' | translate }}</th>
            <th>{{ 'evaluation.Evaluatees' | translate }}</th>
        </tr>
        </thead>
        <tbody>
            <tr ng-repeat="group in vm.list.items">
                <td><a ui-sref="authorized.evaluation.view({ id: group.id })">{{ group.name }}</a></td>
                <td>{{ vm.MomentService.formatTimeStamp(group.deadline) }}</td>
                <td>{{ group.evaluationCount }}</td>
            </tr>
        </tbody>
    </table>
    <pagination list="vm.list"></pagination>
    `
})
export default class {
    constructor (DATATABLES, ListFactory, EvaluationGroupResource, MomentService) {
        this.DATATABLES = DATATABLES;
        this.MomentService = MomentService;
        this.list = ListFactory.createWithPagination(EvaluationGroupResource.query.bind(EvaluationGroupResource));
        this.list.fetch();
    }
}



// WEBPACK FOOTER //
// ./src/app/components/evaluation/list/index.js